import { createTheme, PaletteMode, Theme } from "@mui/material";

export function createAppTheme(mode: PaletteMode): Theme {
  return createTheme({
    palette: {
      mode,
      background:
        mode === "light"
          ? { default: "#f9f9fb", paper: "#ffffff" }
          : { default: "#121212", paper: "#1e1e1e" },
      primary: { main: "#1976d2" },
      secondary: { main: "#9c27b0" },
      ...(mode === "light" ? { text: { primary: "#1a1a1a", secondary: "#555" } } : {}),
    },
    typography: {
      fontFamily: "'Inter', 'Roboto', sans-serif",
      h4: { fontWeight: 600 },
      h6: { fontWeight: 500 },
      subtitle1: { fontWeight: 500 },
    },
    components: {
      MuiAccordion: {
        styleOverrides: {
          root: ({ theme }) => ({
            backgroundColor: theme.palette.background.paper,
            marginBottom: "10px",
            borderRadius: "8px",
            border: `1px solid ${theme.palette.divider}`,
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            "&:before": { display: "none" },
          }),
        },
      },
    },
  });
}
